import classnames from 'classnames'
import { flexRender, Table as TanstackTable } from '@tanstack/react-table'
import { ComponentProps, RefObject } from 'react'
import { Table } from '../..'

type TableBodyProps = {
    table: TanstackTable<unknown>
    hasFooter?: boolean
    tableBodyRef?: RefObject<HTMLTableSectionElement>
    cellClassName?: string
} & Pick<
    ComponentProps<typeof Table>,
    'style' | 'onRowClick' | 'isRowClickable'
>

export const TableBody: React.FC<TableBodyProps> = (props) => {
    const { table, style, onRowClick, isRowClickable, tableBodyRef } = props

    return (
        <tbody ref={tableBodyRef}>
            {table.getRowModel().rows.map((row) => {
                const isClickable =
                    (isRowClickable === undefined || isRowClickable(row)) &&
                    onRowClick !== undefined

                return (
                    <tr
                        key={row.id}
                        className="group/row"
                        data-testid={row.id}
                        role="row"
                        onClick={(event) => {
                            if (
                                isClickable &&
                                !(event.target as Element).closest('button')
                            ) {
                                onRowClick(row)
                            }
                        }}
                    >
                        {row.getVisibleCells().map((cell, index) => {
                            const cellClassName = classnames(
                                `column-${cell.column.id}`,
                                'h-12 py-3 px-4 font-inter text-sm font-normal leading-6 text-neutral-800',
                                'border-neutral-200',
                                'bg-white group-even/row:bg-neutral-50',
                                {
                                    '[&:not(:last-child)]:pr-0':
                                        style === 'list' &&
                                        cell.column.id !== 'select',
                                    'border-r': style !== 'list',
                                    'sticky left-0 z-10': index === 0,
                                    'group-[:hover:not(:has(button:hover))]/row:bg-blue-50 group-[:hover:not(:has(button:hover))]/row:cursor-pointer':
                                        isClickable,
                                    '!bg-blue-100': row.getIsSelected(),
                                    'w-[1px]': cell.column.id === 'select',
                                },
                                props.cellClassName
                            )

                            return (
                                <td
                                    key={cell.id}
                                    className={cellClassName}
                                    data-testid={cell.id}
                                    role="cell"
                                >
                                    {flexRender(
                                        cell.column.columnDef.cell,
                                        cell.getContext()
                                    )}
                                </td>
                            )
                        })}
                    </tr>
                )
            })}
        </tbody>
    )
}
